// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.onu-port-level-0\n{\n}\n.onu-port-level-1\n{\n  background: LightGoldenRodYellow !important;\n}\n.onu-port-level-2\n{\n  background: LightSalmon !important;\n}\n.onu-port-level-3\n{\n  background: LightPink !important;\n}\n.star\n{\n  color: darkred;\n}\n\n", ""]);
// Exports
module.exports = exports;
